// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as City$PorterinFeature from "../../../../shared/core/helpers/City.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as AssetStore$PorterinFeature from "../../../../ui/assets/AssetStore.mjs";
import * as CityConfig$PorterinFeature from "../../domain/repo/types/CityConfig.mjs";
import * as LoadingSpinner$PorterinFeature from "../../../../ui/components/LoadingSpinner.mjs";
import * as PartnersHelper$PorterinFeature from "../helpers/PartnersHelper.mjs";
import * as PartnersFormCmp$PorterinFeature from "./PartnersFormCmp.mjs";
import * as PartnersFormAckCmp$PorterinFeature from "./PartnersFormAckCmp.mjs";
import * as PartnersRepoManager$PorterinFeature from "../../domain/repo/PartnersRepoManager.mjs";
import * as AttachVehicleModalModuleScss from "../styles/AttachVehicleModal.module.scss";

var styles = AttachVehicleModalModuleScss;

var modalStyles = {
  overlay: {
    backgroundColor: "rgba(51, 51, 51, 0.6)"
  }
};

function AttachVehicleModal(Props) {
  var modalState = Props.modalState;
  var close_modal = Props.close_modal;
  var match = React.useState(function () {
        return CityConfig$PorterinFeature.bangalore;
      });
  var setCity = match[1];
  var city = match[0];
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setVehicles = match$1[1];
  var match$2 = React.useState(function () {
        return /* Init */0;
      });
  var setFormSubmitStatus = match$2[1];
  var formSubmitStatus = match$2[0];
  var partnerCities = List.map(PartnersHelper$PorterinFeature.cityToPartnerCity, PartnersHelper$PorterinFeature.getServicableCities(undefined));
  var RepoInstance = PartnersRepoManager$PorterinFeature.getRepo(undefined);
  var cityHandler = function (city) {
    Curry._1(setCity, (function (param) {
            return city;
          }));
  };
  var fetchPartnerVehicles = function (city) {
    ApiUtils$Catalyst.handleAPIRequest((function (param) {
            Curry._1(setVehicles, (function (param) {
                    return {
                            TAG: /* Loading */0,
                            _0: undefined
                          };
                  }));
            return Curry._1(RepoInstance.fetchPartnerVehicles, City$PorterinFeature.cityToGeoRegionId(city));
          }), (function (data) {
            Curry._1(setVehicles, (function (param) {
                    return {
                            TAG: /* Live */1,
                            _0: data
                          };
                  }));
          }), (function (error) {
            Curry._1(setVehicles, (function (param) {
                    return {
                            TAG: /* Error */2,
                            _0: error
                          };
                  }));
          }));
  };
  var submitFormData = function (formData) {
    ApiUtils$Catalyst.handleAPIRequest((function (param) {
            Curry._1(setFormSubmitStatus, (function (param) {
                    return {
                            TAG: /* Loading */0,
                            _0: undefined
                          };
                  }));
            return Curry._1(RepoInstance.submitAttachVehicleForm, formData);
          }), (function (data) {
            Curry._1(setFormSubmitStatus, (function (param) {
                    return {
                            TAG: /* Live */1,
                            _0: data
                          };
                  }));
          }), (function (error) {
            Curry._1(setVehicles, (function (param) {
                    return {
                            TAG: /* Error */2,
                            _0: error
                          };
                  }));
          }));
  };
  var resetForm = function (param) {
    Curry._1(setFormSubmitStatus, (function (param) {
            return /* Init */0;
          }));
  };
  React.useEffect((function () {
          fetchPartnerVehicles(city);
        }), [city]);
  var tmp;
  if (typeof formSubmitStatus === "number") {
    tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: styles["modal-titlebar"]
            }, React.createElement("div", {
                  className: styles.title
                }, React.createElement("b", undefined, "Attach Vehicle Now")), React.createElement("div", {
                  className: "close-btn",
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AssetStore$PorterinFeature.crossIcon,
                      height: 12.0,
                      width: 12.0,
                      quality: 100.0,
                      alt: "Close"
                    }))), React.createElement(PartnersFormCmp$PorterinFeature.make, {
              initialCity: {
                id: City$PorterinFeature.cityToGeoRegionId(city),
                name: city
              },
              submitPartnerDetailsInfo: submitFormData,
              setCity: cityHandler,
              cities: partnerCities,
              vehicles: match$1[0],
              infoSourceList: PartnersHelper$PorterinFeature.getInfoSourceList(undefined)
            }));
  } else {
    switch (formSubmitStatus.TAG | 0) {
      case /* Live */1 :
          var data = formSubmitStatus._0;
          tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                    className: styles["close-btn"] + " " + styles["ack-close-btn"],
                    onClick: (function (param) {
                        Curry._1(setFormSubmitStatus, (function (param) {
                                return /* Init */0;
                              }));
                        Curry._1(close_modal, undefined);
                      })
                  }, React.createElement(NextImage$PorterinFeature.make, {
                        src: AssetStore$PorterinFeature.crossIcon,
                        height: 12.0,
                        width: 12.0,
                        quality: 100.0,
                        alt: "Close"
                      })), React.createElement(PartnersFormAckCmp$PorterinFeature.make, {
                    message: data.message,
                    name: data.name,
                    resetFunc: resetForm
                  }));
          break;
      case /* Loading */0 :
      case /* Error */2 :
          tmp = React.createElement(LoadingSpinner$PorterinFeature.make, {});
          break;
      
    }
  }
  return React.createElement(ReactModal, {
              isOpen: modalState,
              onRequestClose: close_modal,
              closeTimeoutMS: 500,
              style: modalStyles,
              className: "" + styles["attach-vehicle-modal"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: styles["modal-container"] + " " + styles["attach-form-container"]
                  }, tmp)
            });
}

var make = AttachVehicleModal;

export {
  styles ,
  modalStyles ,
  make ,
}
/* styles Not a pure module */
